module.exports = __webpack_public_path__ + "static/media/TAP.5d0add59.png";